import { UtilityService } from '@ecap3/core';

export class DriveUploadQueue {
    public ItemId: string;
    public Name: string;
    public Percentage: number;

    public constructor(ItemId: string, Name: string, Percentage: number, private utilityService?: UtilityService) {
        this.ItemId = ItemId || this.utilityService.getNewGuid();
        this.Name = Name;
        this.Percentage = Percentage;
    }
}
